import SettingsCombinedList from './SettingsCombinedList'
export default SettingsCombinedList
